import IconUp from "./icon-up";

export default IconUp